import React from 'react'
import Hero from '../components/Hero';
import Services from '../components/Services';
import HowItWorks from '../components/HowItWorks';
import Team from '../components/Team';
import Contact from '../components/Contact';
import Testimonials from '../components/Testimonials';
import BlogSection from '../components/BlogSection'
import AboutUsSection from '../components/AboutSection';
import SEOHead from '../components/SEOHead';

const ServicesPage = () => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Service",
    "name": "Codewave Technologies Limited Services - ICT & Telecom Solutions Kenya",
    "description": "Comprehensive ICT and telecom solutions including bulk SMS Kenya, USSD service provider, SMS gateway, mobile payment solutions, API integration, short code services, and IVR solutions for businesses in Kenya",
    "url": "https://www.codewave.co.ke/services",
    "provider": {
      "@type": "Organization",
      "name": "Codewave Technologies Limited",
      "url": "https://www.codewave.co.ke"
    },
    "serviceType": [
      "Bulk SMS Kenya",
      "USSD Service Provider Kenya",
      "SMS Gateway Kenya",
      "Mobile Payment Solutions Kenya",
      "API Integration Services Kenya",
      "Short Code Services Kenya",
      "IVR Solutions Kenya",
      "Voice SMS Services",
      "Enterprise Messaging Solutions",
      "Business SMS Marketing",
      "Customer Engagement Platforms",
      "Digital Communication Solutions"
    ],
    "areaServed": {
      "@type": "Country",
      "name": "Kenya"
    },
    "availableChannel": {
      "@type": "ServiceChannel",
      "serviceLocation": {
        "@type": "Place",
        "name": "Nairobi, Kenya"
      }
    }
  };

  return (
    <>
      <SEOHead
        title="Bulk SMS, USSD & API Integration Services Kenya - Codewave Technologies Limited"
        description="Codewave Technologies Limited offers affordable bulk SMS services in Kenya, best USSD service provider, SMS gateway for businesses, API integration for mobile payments, IVR and voice solutions, short code and USSD setup services. Trusted telecom API provider in Kenya."
        keywords="bulk SMS service provider, USSD application development, short code services Kenya, IVR solutions Kenya, voice SMS services, enterprise messaging solutions, mobile API services, business SMS marketing, customer engagement platforms, digital communication solutions, affordable bulk SMS services in Kenya, best USSD service provider in Kenya, SMS gateway for businesses in Kenya, API integration for mobile payments, IVR and voice solutions for companies, short code and USSD setup services, telecom API provider in Kenya, business messaging solutions Kenya, ICT services Nairobi, telecom company Nairobi Kenya"
        url="https://www.codewave.co.ke/services"
        canonical="https://www.codewave.co.ke/services"
        structuredData={structuredData}
      />
      <Hero />
      <AboutUsSection />
      <Services />
      <HowItWorks />
      <Team />
      <Testimonials />
      <BlogSection />
      <Contact />
    </>
  )
}

export default ServicesPage